import { fleetManagementUtil } from "../../../../utils";

const formatParsedData = (parsedData) => {
  const devices = fleetManagementUtil.formatDevices(parsedData);

  const formattedData = devices.map((device, index) => {
    const isDusnValid =
      device?.dusn && device?.dusn?.length === 22 && device?.dusn?.startsWith("0x00");
    const isCodentifyValid = device?.codentify && device.codentify.length === 14;

    return {
      ...device,
      index: index + 1,
      correct: !!(isDusnValid && isCodentifyValid && device?.device_model && device?.type),
      errors: {
        dusn: !isDusnValid,
        codentify: !isCodentifyValid
      }
    };
  });

  return formattedData;
};

const formatRecords = (records) => {
  return records.map((record) => {
    delete record["index"];
    delete record["correct"];
    delete record["deviceImage"];
    delete record["deviceModel"];
    delete record["deviceName"];
    delete record["isMercuryDevice"];
    delete record["errors"];

    record.latest_firmware_version_update_datetime = "";

    return record;
  });
};

export const formatUtils = {
  formatParsedData,
  formatRecords
};
